import { render } from "./EditTag.vue?vue&type=template&id=dfcf16cc&scoped=true&ts=true"
import script from "./EditTag.vue?vue&type=script&lang=ts"
export * from "./EditTag.vue?vue&type=script&lang=ts"

import "./EditTag.vue?vue&type=style&index=0&id=dfcf16cc&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfcf16cc"]])

export default __exports__